import { useCallback } from 'react'
import Box from '@mui/material/Box'

const UsernameInput = ({ toUsername, onChange }) => {
  const handleChange = useCallback(
    (e) => {
      onChange(e.target.value)
    },
    [onChange]
  )

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        '& input': {
          flex: 1,
          border: 0,
          outline: 0,
          backgroundColor: 'transparent',
          color: 'text.primary',
          fontSize: '20px',
          borderWidth: 1,
          borderColor: 'divider',
          borderStyle: 'solid',
          p: 1.5,
          borderRadius: 2,
        },
      }}
    >
      <input
        type="text"
        value={toUsername}
        onChange={handleChange}
        placeholder="e.g. johnny123"
        spellCheck={false}
      />
    </Box>
  )
}

export default UsernameInput
